import type { GoodsSku } from "../types/shopGoods";

interface GoodsPricingInput {
  isMultiSpecification?: number | null;
  price?: number;
  marketPrice?: number | null;
  stock?: number;
  skuList?: GoodsSku[];
}
interface GoodsPricing {
  price?: number;
  marketPrice?: number | null;
  stock?: number;
}

export function getGoodsPricing(goods: GoodsPricingInput): GoodsPricing {
  if (goods.isMultiSpecification !== 1) {
    return { price: goods.price, marketPrice: goods.marketPrice, stock: goods.stock };
  }
  if (!goods.skuList) return {};
  const enabled = goods.skuList.filter((sku) => sku.status == null || sku.status === 1);
  const lowest = enabled.reduce<GoodsSku | undefined>((current, sku) => {
    if (!Number.isFinite(sku.price) || sku.price < 0) return current;
    return !current || sku.price < current.price ? sku : current;
  }, undefined);
  return {
    price: lowest?.price,
    marketPrice: lowest?.marketPrice ?? null,
    stock: enabled.reduce((total, sku) => total + (Number.isFinite(sku.stock) && sku.stock >= 0 ? sku.stock : 0), 0),
  };
}
